import React, { useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight } from 'lucide-react';

const HERO_VIDEO = "https://customer-assets.emergentagent.com/job_tulum-investment-lab/artifacts/5ceeodpn_magnific_cinematic-camera-movement_MX9MvpVDCm.mp4";
const WHATSAPP_LINK = "https://wa.me/529841585732?text=Hola%2C%20vi%20la%20p%C3%A1gina%20de%20Marea%20Riviera%20y%20quiero%20una%20asesor%C3%ADa%20sin%20costo.";

export const Hero = () => {
  const { language } = useLanguage();
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) videoRef.current.play().catch(() => {});
  }, []);

  return (
    <section id="hero" data-testid="hero-section" className="relative h-screen overflow-hidden">
      <video ref={videoRef} className="absolute inset-0 w-full h-full object-cover scale-105" src={HERO_VIDEO} muted loop playsInline preload="auto" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A2235]/40 via-[#0A2235]/30 to-[#0A2235]/70" />

      <div className="relative z-10 h-full flex flex-col justify-between px-6 md:px-16 lg:px-24 pt-32 pb-16">
        {/* Top: Main heading aligned left like Aurven */}
        <div className="max-w-4xl">
          <h1 className="font-playfair text-[clamp(2.5rem,7vw,5.5rem)] text-[#FAFAF7] leading-[1.05] tracking-tight" data-testid="hero-title">
            {language === 'es' ? (
              <>Inversión inmobiliaria que mereces llamar <em className="text-[#7ECFCF]">hogar</em></>
            ) : (
              <>Real estate investment you truly deserve to call <em className="text-[#7ECFCF]">home</em></>
            )}
          </h1>

          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center mt-10 group"
            data-testid="hero-cta-button"
          >
            <span className="font-inter text-[#FAFAF7] text-sm tracking-wider border border-[#FAFAF7]/30 px-6 py-3 rounded-l-full group-hover:bg-[#FAFAF7]/10 transition-colors">
              {language === 'es' ? 'Explorar propiedades' : 'Explore properties'}
            </span>
            <span className="bg-[#0A2235] border border-[#FAFAF7]/30 border-l-0 p-3 rounded-r-full group-hover:bg-[#2BBFBF] transition-colors">
              <ArrowRight className="w-5 h-5 text-[#FAFAF7] group-hover:translate-x-0.5 transition-transform" />
            </span>
          </a>
        </div>

        {/* Bottom: Large brand text like Aurven */}
        <div className="overflow-hidden">
          <p className="font-playfair text-[clamp(3rem,11vw,12rem)] text-[#FAFAF7]/10 leading-none tracking-tight whitespace-nowrap select-none notranslate" translate="no">
            Marea Riviera
          </p>
        </div>
      </div>
    </section>
  );
};
